module.exports = __webpack_public_path__ + "img/titleProducts.3eebc3e6.png";